<template>
    <div class="landing">
        <TransitionEffect>
            <WaitlistModal
                v-if="waitlistModal"
                @close="waitlistModal=false"/>
        </TransitionEffect>
        
        <MovingBubbles/>
        
        <div class="animation instant">
            <header class="header">
                <Logo/>
            </header>
            <Proposition
                :content="content"
                @openWaitlistModal="waitlistModal=true"
                @changeView="$emit('changeView')"/>
            <Hero/>
        </div>
        <div class="animation delay">
            <Love class="landingSection"
                :content="content"/>
            <Comparison class="landingSection"
                :content="content"/>
            <Uploader class="landingSection"
                :content="content"/>
            <Visibility class="landingSection"
                :content="content"/>
            <Waitlist
                :content="content"
                @openWaitlistModal="waitlistModal=true"/>
        </div>
    </div>
</template>

<script>
    import content       from '@/components/landing/lang/landing.js'

    import MovingBubbles from '@/components/templates/MovingBubbles'
    import Proposition   from '@/components/landing/Proposition'
    import Love          from '@/components/landing/Love'
    import Hero          from '@/components/landing/Hero'
    import WaitlistModal from '@/components/landing/WaitlistModal'
    import Comparison    from '@/components/landing/Comparison'
    import Uploader      from '@/components/landing/Uploader'
    import Visibility    from '@/components/landing/Visibility'
    import Waitlist      from '@/components/landing/Waitlist'

    export default {
        name: 'Landing',
        components: {
            MovingBubbles,
            Proposition,
            Love,
            Hero,
            WaitlistModal,
            Comparison,
            Uploader,
            Visibility,
            Waitlist
        },
        data() {
            return {
                waitlistModal: false
            }
        },
        computed: {
            content() {
                return this.getContent(content)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .landing {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 1rem 2rem 8rem 2rem;
        overflow: hidden;
    }

    .header {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 1rem;
    }

    .landingSection {
        margin-bottom: 12rem;
    }

    .animation {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .instant {
        animation: fade 1s ease-in-out;
    }

    @keyframes fade {
        0% {
            opacity: 0;
            transform: translateY(4rem);
        }

        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .delay {
        animation: fade-delay 5s ease-in-out;
    }

    @keyframes fade-delay {
        0% {
            opacity: 0;
        }

        75% {
            opacity: 0;
            transform: translateY(8rem);
        }

        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media all and (max-width: 1024px) {
        .landing {
            padding: 1rem 1rem 4rem 1rem;
        }
    }

    @media all and (max-width: 560px) {
        .landing {
            padding: 0.5rem;
        }
    }
</style>